import React, {useState} from 'react';
import {css, StyleSheet} from "aphrodite";
import TextDiv from "../containers/TextDiv";
import Config from "../../config/Config";
import {Link} from "react-router-dom";
import Image from "../containers/Image";
import MediaQuery from "../../styles/MediaQuery";
import Countries from "../../utils/Countries";

const QrArea = ({extraStyle}) => {
        const countries = [];
        const [isSmsForm, setIsSmsForm] = useState(true);
        const [isWaiting,setIsWaiting] = useState(false);


        // Send Request:
        function sendRequest(isSmsForm) {
            if(!isWaiting) {

                setIsWaiting(true);

                var requestUrl = Config.apis.INVITE;

                if (isSmsForm) {
                    var countryCode = '+' + document.getElementById('country_code').value;
                    var phoneNumber = document.getElementById('phone').value;

                    requestUrl += '/sms?country_code=' + countryCode + '&phone=' + phoneNumber;
                } else {
                    var userEmail = document.getElementById('email').value; // Get Input Value
                    requestUrl += '/email?email=' + userEmail;
                }

                var xhr = new XMLHttpRequest()
                xhr.open("GET", requestUrl, true)
                xhr.onload = function (e) {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            var response = JSON.parse(xhr.response);
                            alert(response.message);
                            setIsWaiting(false);
                        } else {
                            alert('Error. Please try again later');
                            setIsWaiting(false);
                        }
                    }
                    // Wait?
                }.bind(this)
                xhr.onerror = function (e) {
                    alert('Error. Please try again later');
                    setIsWaiting(false);
                }
                xhr.send(null)
            }
        }



        const styles = StyleSheet.create({
            qrArea: {
                display: 'flex',
                flexDirection: 'column',
                marginTop: '30px'
            },
            phoneInput: {
                width: '80%',
                display: 'flex',
                alignItems: 'center'
            },
            input: {
                height: '40px',
                width: '60%',
                minHeight: '40px',
                border: 0,
                padding: '0 15px',
            },
            select: {
                height: '40px',
                width: '40%',
                minHeight: '40px',
                border: 0,
                padding: '0 15px',
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: '13px',
                textTransform: 'capitalize'
            },
            button: {
                backgroundColor: Config.colors.FEEDBACK_BUTTON,
                color: Config.colors.SECONDARY_TEXT,
                border: 0,
                borderRadius: 0,
                fontSize: 15,
                lineHeight: 1.8,
                letterSpacing: 0.2,
                padding: "10px 30px",
                textAlign: "center",
                width: "max-content",
                height: "fit-content",
                display: "grid",
                marginTop: '10px',
                alignItems: "center",
                ':hover': {
                    cursor: "pointer",
                    backgroundColor: Config.colors.FEEDBACK_BUTTON_HOVER,
                    transition: "background-color 0.1s cubic-bezier(0.4, 0, 0.2, 1) 0s"
                },
                ...MediaQuery.mobile({
                    fontSize: 12,
                    lineHeight: 1.67,
                    letterSpacing: 0.18,
                    padding: "9px 20px 7px 20px",
                })
            },
            buttonGrey: {
                backgroundColor: "rgb(96 98 104) !important",
                color: Config.colors.SECONDARY_TEXT,
                border: 0,
                borderRadius: 0,
                fontSize: 15,
                lineHeight: 1.8,
                letterSpacing: 0.2,
                padding: "10px 30px",
                textAlign: "center",
                width: "max-content",
                height: "fit-content",
                display: "grid",
                marginTop: '10px',
                alignItems: "center",
                ':hover': {
                    cursor: "progress",
                    backgroundColor: "rgb(96 98 104) !important",
                    transition: "background-color 0.1s cubic-bezier(0.4, 0, 0.2, 1) 0s"
                },
                ...MediaQuery.mobile({
                    fontSize: 12,
                    lineHeight: 1.67,
                    letterSpacing: 0.18,
                    padding: "9px 20px 7px 20px",
                })
            },
            linkWrapper: {
                position: 'relative',
                zIndex: 3,
            },
            linkText: {
                lineHeight: '2',
                textDecoration: 'underline',
                textTransform: 'lowercase',
                cursor: 'pointer'
            },
            appImageWrapper: {
                display: 'flex',
                alignItems: 'flex-end'
            },
            appImage: {
                width: '150px',
                marginRight: '30px',
                cursor: 'pointer',
            }
        })
        return (
            <div className={css(styles.qrArea)}>
                {
                    Object.keys(Countries).forEach(function (country, key) {
                        countries.push(Countries[country]);
                    })
                }
               
                    <input name="email" id="email" className={css(styles.input)} type="text" placeholder={'Your email address'}/> 

                {!isWaiting ?
                    <button id="btnSendLink" className={css(styles.button)} onClick={() => sendRequest(false)}>
                     
                            <TextDiv text={Config.messages.emailMeLink}/>
                          
                    </button>
                    :
                    <button id="btnSendLinkFake" className={css(styles.buttonGrey)}>
                        Loading...
                    </button>
                }

                <br />

                <div className={css(styles.appImageWrapper)}>
                    <Link to={{ pathname: "https://play.google.com/store/apps/details?id=com.avast.android.secure.browser&referrer=utm_source%3Davast_com%26utm_medium%3Dxpromo_lp%26utm_campaign%3Dd2m"}} target="_blank"><Image extraStyle={styles.appImage} src={Config.images.PLAY_STORE}/></Link>
                    <Link to={{ pathname: "https://apps.apple.com/app/apple-store/id1517761023?pt=421899&ct=asb_qr_d2m"}} target="_blank"><Image extraStyle={styles.appImage} src={Config.images.APP_STORE}/></Link>
                </div>
            </div>
        );
    }
;

export default QrArea;
